var map = {
	"./Ipad-picture.png": 193,
	"./arrow-right.svg": 5327,
	"./back-arrow.svg": 5691,
	"./back-icon-2.png": 763,
	"./back-icon-white.png": 6630,
	"./back-icon.png": 565,
	"./bar-logos/brew-on-quay-colored.png": 6077,
	"./bar-logos/brew-on-quay.png": 6176,
	"./bar-logos/cafe-runddelen-colored.png": 8934,
	"./bar-logos/cafe-runddelen.png": 743,
	"./bar-logos/fagans-colored.png": 2236,
	"./bar-logos/fagans.png": 968,
	"./bar-logos/flying-barrel-colored.png": 8924,
	"./bar-logos/flying-barrel.png": 911,
	"./bar-logos/fr-vi-colored.png": 4270,
	"./bar-logos/fr-vi.png": 8116,
	"./bar-logos/freddys-bar-colored.png": 7180,
	"./bar-logos/freddys-bar.png": 4167,
	"./bar-logos/globe-colored.png": 9763,
	"./bar-logos/globe.png": 7114,
	"./bar-logos/good-spirits-hospitality-colored.png": 9576,
	"./bar-logos/good-spirits-hospitality.png": 1850,
	"./bar-logos/interpool-colored.png": 47,
	"./bar-logos/interpool.png": 28,
	"./bar-logos/johns-colored.png": 1272,
	"./bar-logos/johns.png": 1430,
	"./bar-logos/malmo-sportbar-colored.png": 19,
	"./bar-logos/malmo-sportbar.png": 6142,
	"./bar-logos/proud-mary-pub-colored.png": 3143,
	"./bar-logos/proud-mary-pub.png": 919,
	"./bar-logos/pubsport-colored.png": 1696,
	"./bar-logos/pubsport-half-padding.png": 1483,
	"./bar-logos/pubsport.png": 5683,
	"./bar-logos/rekom-colored.png": 164,
	"./bar-logos/rekom.png": 3578,
	"./bar-logos/shamrock-colored.png": 2272,
	"./bar-logos/shamrock.png": 3054,
	"./bar-logos/the-cav-colored.png": 3576,
	"./bar-logos/the-cav.png": 6325,
	"./bar-logos/the-fox-colored.png": 1932,
	"./bar-logos/the-fox.png": 4597,
	"./bar-logos/the-kingslander-colored.png": 9044,
	"./bar-logos/the-kingslander.png": 9690,
	"./benefits-icons/attract-icon.png": 2871,
	"./benefits-icons/marketing-icon.png": 71,
	"./benefits-icons/savemoney-icon.png": 5769,
	"./benefits-icons/savetime-icon.png": 3308,
	"./book-demo.png": 4437,
	"./checkmark.svg": 5280,
	"./contact-us.png": 2991,
	"./divider/barsimg.svg": 4041,
	"./divider/fansimg.svg": 6008,
	"./facebook.svg": 3536,
	"./footer_background.png": 6210,
	"./footer_background_mobile.png": 1215,
	"./footer_background_tablet.png": 4631,
	"./half-circles-horizontal.svg": 6260,
	"./half-circles.svg": 3348,
	"./hamburger.svg": 6691,
	"./instagram.svg": 5397,
	"./laptop-image.png": 4602,
	"./logo-no-text.png": 2661,
	"./logo-no-text.svg": 4406,
	"./logo-white.svg": 8189,
	"./logo.svg": 2835,
	"./megaphone-man-small.png": 5498,
	"./megaphone-man.png": 7786,
	"./pricing-mobile.png": 7811,
	"./pricing.png": 2390,
	"./quotationmark.svg": 6684,
	"./testimonial-background.png": 1152,
	"./testimonial-pics/Jakob_Heiberg.png": 2992,
	"./testimonial-pics/Karina_Kjær.png": 5233,
	"./testimonial-pics/Naoise_Mac_Namara.png": 5137,
	"./testimonial-pics/default_profile_pic.png": 1587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;